export default [
  {
    text: 'Да',
    value: true,
  },
  {
    text: 'Нет',
    value: false,
  },
];
